<script lang="ts">
	import { Category, categoryAboutMap, categoryNameMap, categoryTextMap } from "../../../../core/schema/Category.js";
	import racks from "../assets/images/solutions/racks.jpg?webp&h=280&imagetools";
	import cranes from "../assets/images/solutions/cranes.png?webp&h=280&imagetools";
	import robots from "../assets/images/solutions/robots.png?webp&h=280&imagetools";
	import vertinodeAi from "../assets/images/solutions/vertinode.jpg?webp&h=280&imagetools";
	import Card from "../../../shared/components/Card.svelte";
	import type { Product } from "../../../../core/schema/Product.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { getSolutionSubcategoryPath } from "../../../../core/schema/paths/getSolutionSubcategoryPath.js";

	export let categories: Category[];
	export let vertinodeAiProduct: Product;

	const { TENANT_LOCALE } = getGlobalSettings();

	const categoryImageMap: Record<Category, string> = {
		[Category.Cranes]: cranes,
		[Category.Racks]: racks,
		[Category.Robots]: robots,
		[Category.VertinodeAi]: vertinodeAi,
	};
</script>

<div class="flex flex-col gap-2 md:grid md:grid-cols-2 xl:grid-cols-4">
	{#each categories as category, index}
		<Card
			image={categoryImageMap[category]}
			title={categoryNameMap[category][TENANT_LOCALE]}
			description={categoryTextMap[category][TENANT_LOCALE]}
			urlSlug={getSolutionSubcategoryPath(category, vertinodeAiProduct)[TENANT_LOCALE]}
			squaredImage={true}
			customButtonText={index > 0 ? categoryAboutMap[category][TENANT_LOCALE] : undefined}
		/>
	{/each}
</div>
